import ReactionModal from "./reaction.vue";

export default ReactionModal;



// WEBPACK FOOTER //
// ./src/components/_modals/reaction/index.js